/**
 * Status of a queued auth-provider account deletion.
 */
export enum AccountDeletionEventStatusEnum {
  /**
   * Waiting to be leased.
   */
  PENDING = 'pending',

  /**
   * Claimed by a deletion run.
   */
  LEASED = 'leased',

  /**
   * The deletion finished, or there was no renter account to delete.
   */
  COMPLETED = 'completed',

  /**
   * The latest deletion attempt failed. Leased again until the retry cap.
   */
  FAILED = 'failed',
}
